<template>
    <transition name="toast">
      <div
        v-if="isVisible"
        class="fixed top-0 left-1/2 transform -translate-x-1/2 z-50 text-white px-4 py-2 rounded-b-lg shadow-lg"
        :class="backgroundClass"
      >
        {{ message }}
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: 'ToastNotification',
    props: {
      message: {
        type: String,
        required: true,
      },
      backgroundClass: {
        type: String,
        default: 'bg-green-500', // Default to green for success
      },
      duration: {
        type: Number,
        default: 3000, // Default to 3 seconds
      },
    },
    data() {
      return {
        isVisible: false,
      };
    },
    methods: {
      show() {
        this.isVisible = true;
        setTimeout(() => {
          this.isVisible = false;
          this.$emit('closed'); // Emit event when toast hides
        }, this.duration);
      },
    },
    watch: {
      message(newMessage) {
        if (newMessage) {
          this.show(); // Automatically show when message changes
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Toast animation */
  .toast-enter-active,
  .toast-leave-active {
    transition: all 0.5s ease;
  }
  .toast-enter-from,
  .toast-leave-to {
    transform: translate(-50%, -100%); /* Slide from top */
    opacity: 0;
  }
  .toast-enter-to,
  .toast-leave-from {
    transform: translate(-50%, 0); /* Slide to visible position */
    opacity: 1;
  }
  </style>